import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-12 md:py-24 bg-dark-800 relative" data-id="element-81">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-83">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-84">
            Si estás alimentando a tu perro o gato con comida industrial, hay
            algo que debes saber:
          </h2>

          <p className="text-2xl md:text-4xl text-earth-amber font-serif italic mb-10" data-id="element-85">
            "No sabes realmente qué está comiendo."
          </p>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 max-w-3xl mx-auto font-light" data-id="element-86">
            <p data-id="element-87">
              Piensos ultraprocesados, ingredientes de baja calidad,
              conservantes… y lo peor: una dieta repetitiva que no se adapta a
              su edad, ni a sus necesidades reales.
            </p>
            <p data-id="element-88">Y mientras tanto, tú crees que lo estás haciendo bien.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}